<template>
	<div class="batch-import-task-page page-layout">
		<gc-header headerData="moduleManage">
			<template #ops>
				<el-button v-has="'monitor:imei:device:regist'" type="primary" @click="moduleModalVisible = true">
					模组注册
				</el-button>
				<el-button v-has="'monitor:imei:device:export'" v-click-blur @click="handleDeviceExport">
					导 出
				</el-button>
			</template>
		</gc-header>
		<div class="run-main">
			<div class="serach">
				<gc-advanced-filter
					v-model="form"
					:fields="filterFields"
					@search="handleQuerySearch"
					@reset="handleQueryReset"
				/>
				<gc-column-setting
					storageKey="localcolumn-om-module-manage"
					:columns="columns"
					@update-column="data => (columns = data)"
				></gc-column-setting>
			</div>
			<div class="table-show" v-loading="loading">
				<gc-table
					border
					showPage
					:columns="columnList"
					:table-data="tableData"
					:current-page.sync="pagination.currentPage"
					:total="pagination.total"
					:pageSize="pagination.pageSize"
					gloabSortDisable
					@current-page-change="handleCurrentPageChange"
					@size-change="handlePageSizeChange"
				></gc-table>
			</div>
		</div>
		<OperateModuleModal
			v-if="moduleModalVisible"
			:deviceGroupOptions="deviceGroupOptions"
			@close-modal="handleCloseModal"
		/>
	</div>
</template>

<script>
import {
	apiGetModulePageList,
	apiGetDeviceGroupPageList,
	apiCreateImeiModule,
	apiUnRegisterImeiModule,
} from '@/apis/communicationModelManage.api'
import { apiGetDeviceTypeImeiList } from '@/apis/account.api'
import { apiManufacturerList } from '@/apis/factory.api'
import { exportReport } from '@/apis/statisticAnalysis.api'
import { MODULE_REGISTER_STATUS_OPTIONS } from '@/config/const'
import OperateModuleModal from './components/OperateModuleModal'

export default {
	name: 'deviceGroup',
	components: { OperateModuleModal },
	data() {
		return {
			MODULE_REGISTER_STATUS_OPTIONS,
			form: {
				deviceNo: null,
				imei: null,
				deviceTypeIdList: null,
				manufacturerId: null,
				deviceGroupName: null,
				deviceImeiRegistStatus: null,
			},
			columns: [
				{
					key: 'deviceNo',
					name: '设备通讯编号',
					tooltip: true,
					dragDisable: true,
					disabledSelect: true,
				},
				{
					key: 'imei',
					name: 'IMEI',
				},
				{
					key: 'deviceTypeName',
					name: '设备类型',
				},
				{
					key: 'manufacturerName',
					name: '厂商',
				},
				{
					key: 'deviceGroupName',
					name: '设备组名称',
					tooltip: true,
				},
				{
					key: 'statusName',
					name: '注册状态',
				},
				{
					key: 'oprate',
					name: '操作',
					sortDisable: true,
					width: 180,
					render: (h, row) => {
						return h(
							'div',
							null,
							[
								row.manufacturerId === this.manufacturerId &&
								['2', '3'].includes(row.deviceImeiRegistStatus) &&
								this.$has('monitor:imei:device:regist')
									? h(
											'el-button',
											{
												props: { type: 'text', size: 'medium' },
												on: {
													click: () => this.handleOperate(row, 'register'),
												},
											},
											'重新注册',
									  )
									: null,
								row.manufacturerId === this.manufacturerId &&
								['1'].includes(row.deviceImeiRegistStatus) &&
								this.$has('monitor:imei:device:unregist')
									? h(
											'el-button',
											{
												style: { color: '#e5662e' },
												props: { type: 'text', size: 'medium' },
												on: {
													click: () => this.handleOperate(row, 'cancel'),
												},
											},
											'注销',
									  )
									: null,
								h(
									'el-button',
									{
										props: { type: 'text', size: 'medium' },
										on: {
											click: () => this.handleOperate(row, 'detail'),
										},
									},
									'详情',
								),
							].filter(Boolean),
						)
					},
				},
			],
			loading: false,
			pagination: {
				currentPage: 1,
				pageSize: 20,
				total: 0,
			},
			tableData: [],
			moduleModalVisible: false,
			deviceGroupOptions: [],
			manufacturerListOptions: [],
			deviceTypeListOptions: [],
		}
	},

	created() {
		this.queryDeviceGroupOptions()
		this.queryManufacturerList()
		this.queryDeviceTypeList()
		this.queryTableDataPageList()
	},

	methods: {
		async queryDeviceGroupOptions() {
			const data = await apiGetDeviceGroupPageList({
				manufacturerId: this.manufacturerId,
				current: 1,
				size: 10000,
			})
			this.deviceGroupOptions = (data.records || []).sort((x, y) => y.status - x.status)
		},

		async queryManufacturerList() {
			const data = await apiManufacturerList({ current: 1, size: 1000 })
			this.manufacturerListOptions = (data.records || []).map(m => {
				return {
					value: m.manufacturerId,
					label: m.manufacturerName,
				}
			})
		},

		async queryDeviceTypeList() {
			const data = await apiGetDeviceTypeImeiList(this.tenantId)
			this.deviceTypeListOptions = (data.records || []).map(item => {
				return {
					value: item.deviceTypeId,
					label: item.deviceTypeName,
				}
			})
		},

		async queryTableDataPageList() {
			this.loading = true
			const searchParams = {
				...this.form,
				manufacturerId: this.manufacturerId === 0 ? this.form.manufacturerId : this.manufacturerId,
				current: this.pagination.currentPage,
				size: this.pagination.pageSize,
			}
			try {
				const { records = [], total } = await apiGetModulePageList(searchParams)
				this.tableData = records
				this.pagination.total = total
			} finally {
				this.loading = false
			}
		},

		handleDeviceExport() {
			if (!this.tableData.length) {
				return this.$message.warning('暂无表格数据')
			}
			const searchParams = {
				...this.form,
				manufacturerId: this.manufacturerId === 0 ? this.form.manufacturerId : this.manufacturerId,
			}
			this.$toast('下载中，请稍后...')
			const data = {
				method: 'post',
				url: '/monitor/report/device-imei-regist/export/excel',
				fileName: '模组列表.xlsx',
				data: searchParams,
			}
			exportReport(data, 'excel', '', this.$toast)
		},

		async handleOperate(rowItem, type) {
			if (type === 'detail') {
				this.$router.push({
					path: '/communication-model-manage/module-manage/details',
					query: { id: rowItem.id, uuid: rowItem.uuid },
				})
			} else if (type === 'register') {
				await apiCreateImeiModule({ ...rowItem, manufacturerId: this.manufacturerId })
				this.$message.success('注册成功')
				this.queryTableDataPageList()
			} else if (type === 'cancel') {
				await apiUnRegisterImeiModule({ ...rowItem, manufacturerId: this.manufacturerId })
				this.$message.success('注销成功')
				this.queryTableDataPageList()
			}
		},

		handleCurrentPageChange(current) {
			this.pagination.currentPage = current
			this.queryTableDataPageList()
		},

		handlePageSizeChange(size) {
			this.pagination.currentPage = 1
			this.pagination.pageSize = size
			this.queryTableDataPageList()
		},

		handleQuerySearch() {
			this.pagination.currentPage = 1
			this.queryTableDataPageList()
		},

		handleQueryReset() {
			for (const key in this.form) {
				this.form[key] = null
			}
			this.pagination.currentPage = 1
			this.queryTableDataPageList()
		},

		handleCloseModal(refresh) {
			this.moduleModalVisible = false
			if (refresh) {
				this.handleQueryReset()
			}
		},
	},

	computed: {
		columnList() {
			return this.columns.filter(o => o.selected)
		},

		tenantId() {
			return this.$store.getters.userInfo.tenantId || null
		},

		manufacturerId() {
			return this.$store.getters.userInfo.manufacturerId
		},

		filterFields() {
			return [
				{ prop: 'deviceNo', label: '设备通讯编号', type: 'input' },
				{ prop: 'imei', label: 'IMEI', type: 'input' },
				{
					prop: 'deviceTypeIdList',
					label: '设备类型',
					type: 'select',
					props: {
						searchOption: this.deviceTypeListOptions,
						needAllForSearch: true,
						filterable: true,
						multiple: true,
					},
				},
				{ prop: 'deviceGroupName', label: '设备组名称', type: 'input' },
				{
					prop: 'manufacturerId',
					label: '厂商',
					type: 'select',
					props: {
						searchOption: this.manufacturerListOptions,
						needAllForSearch: true,
						filterable: true,
					},
					hidden: this.manufacturerId !== 0,
				},
				{
					prop: 'deviceImeiRegistStatus',
					label: '注册状态',
					type: 'select',
					props: {
						searchOption: this.MODULE_REGISTER_STATUS_OPTIONS,
						needAllForSearch: true,
					},
				},
			].filter(item => !item.hidden)
		},
	},
}
</script>
<style lang="scss" scoped>
@import '../../run-manage/runLayout.scss';
</style>
